import { createContext } from "react";

/**
 * context for click analytics for category links inside media categories
 */
export const CategoryLinkAnalyticsContext = createContext({
    sendCategoryLinkAnalytics: () => {},
    sendCategoryBubbleAnalytics: () => {},
});
